module.exports = __webpack_public_path__ + "img/af.80deffc5.svg";